export enum StorageKeys {
  SITE_ID = 'siteId',
  PAYMENT_USER_EMAIL = 'paymentUserEmail',
  GOOGLE_APPOINTMENT_BID = 'google-appointment-bid',
  GOOGLE_APPOINTMENT_TOKEN = 'google-appointment-token',
  GOOGLE_APPOINTMENT_TOKEN_AVAILABLE = 'google-appointment-token-available',
}

export const { SITE_ID, PAYMENT_USER_EMAIL } = StorageKeys
